import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgC3 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(2 27)",
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(7 2)",
				fill: "#1D1D1B",
				fillRule: "nonzero",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						x: 44,
						width: 2,
						height: 22,
						rx: .9
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 39,
						width: 2,
						height: 22,
						rx: .9
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 5,
						width: 2,
						height: 22,
						rx: .9
					}),
					/* @__PURE__ */ _jsx("rect", {
						width: 2,
						height: 22,
						rx: .9
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.29 15.694a2 2 0 00.55 1.26 1.78 1.78 0 001.29.45c.48.027.953-.13 1.32-.44a2.91 2.91 0 00.77-1.1c.18-.45.305-.92.37-1.4.06-.5.12-1 .15-1.38a2.88 2.88 0 01-1.14 1.13 3.28 3.28 0 01-1.59.38 4.26 4.26 0 01-1.63-.3 3.77 3.77 0 01-2.09-2.22 5.11 5.11 0 01-.29-1.76 4.93 4.93 0 01.29-1.7 3.82 3.82 0 012.22-2.28 4.81 4.81 0 011.83-.33 4.17 4.17 0 012.2.52 3.66 3.66 0 011.36 1.4 6.49 6.49 0 01.7 2.1c.135.853.202 1.716.2 2.58 0 .77-.083 1.538-.25 2.29a6.88 6.88 0 01-.8 2.1 4.61 4.61 0 01-1.47 1.54 4.31 4.31 0 01-3.67.34 3.8 3.8 0 01-1.18-.7 3.54 3.54 0 01-.83-1.08 3.42 3.42 0 01-.37-1.4h2.06zm2-8a2.13 2.13 0 00-1 .21 1.89 1.89 0 00-.68.57 2.58 2.58 0 00-.41.83 3.49 3.49 0 00-.13 1c-.003.337.041.674.13 1 .084.303.223.588.41.84a2 2 0 00.68.59 2 2 0 001 .22 2.25 2.25 0 001-.21 2.08 2.08 0 00.72-.59 2.93 2.93 0 00.42-.85 3.31 3.31 0 00.14-1 3.16 3.16 0 00-.14-1 2.65 2.65 0 00-.42-.82 2.14 2.14 0 00-.72-.57 2.25 2.25 0 00-1.06-.19l.06-.03z",
				fill: "#1D1D1B",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("rect", {
				stroke: "#0D0E10",
				strokeWidth: 2,
				x: -1,
				y: -1,
				width: 62,
				height: 28,
				rx: 2
			})
		]
	})
});
export default SvgC3;
